import React, {Component} from "react"

import {Grid, Container} from "semantic-ui-react"

import Responsive from "react-responsive"
import WordPressContainer from "WordPressContainer"
import CategoriesGrid from "components/Category/CategoriesGrid"
import NavigationSidebar from "components/Navigation/NavigationSidebar"

export default class LandingPage extends Component {
  componentDidMount() {
    
  }

  render() {
    return (
      <Container className="">
        <section className="pb4">
          <WordPressContainer slug="startseite"/>
        </section>
      </Container>
    )
  }
}




// WEBPACK FOOTER //
// ./src/theme/base/pages/LandingPage.js